import React from 'react'
import SkillBlock from './SkillBlock'
import { motion } from 'framer-motion'
import { database_icons, development_icons, programming_icons, tools_icons } from '../data/skills'
const Skills = () => {

  return (
    <div name="Skills" className='pt-20 w-full h-fit  text-white '>
      <div className='max-w-screen-lg px-4 pt-12  pb-36 mx-auto flex flex-col justify-center  '>
        <div className=''>
          <div>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >

              <p className='text-4xl font-bold inline border-b-4 border-gray-400'>Skills</p>
            </motion.div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 90 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >

            <SkillBlock icons={programming_icons} title={`Programming Languages`} />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 150 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
          >

            <SkillBlock icons={development_icons} title={`Development`} myStyle={"shadow-red-400 overflow-y-auto sm:h-[36rem] h-[40rem] overflow-x-hidden"} />
            <SkillBlock icons={database_icons} title={`Database`} />
            <SkillBlock icons={tools_icons} title={`Tools`} />
          </motion.div>

        </div>
      </div>
    </div>
  )
}

export default Skills
